import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "styled-components";
var _excluded = ["className", "css", "isPremium"];
import cn from "classnames";
import { LockCircle, StarCircle } from "@crehana/icons/fill";
import usePremiumExclusiveTagTranslation from "./hooks/usePremiumExclusiveTagTranslation";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PremiumExclusiveTag = function PremiumExclusiveTag(_ref) {
  var className = _ref.className,
    css = _ref.css,
    isPremium = _ref.isPremium,
    premiumExclusiveTagProps = _objectWithoutProperties(_ref, _excluded);
  var _usePremiumExclusiveT = usePremiumExclusiveTagTranslation(),
    t = _usePremiumExclusiveT.t;
  var Icon = isPremium ? StarCircle : LockCircle;
  return /*#__PURE__*/_jsxs(_StyledP, _objectSpread(_objectSpread({
    className: cn('inline-flex items-center bg-base-main-56 font-label text-white pl-2 py-2 pr-8', className)
  }, premiumExclusiveTagProps), {}, {
    $_css: css,
    children: [/*#__PURE__*/_jsx(Icon, {
      size: 28,
      ignoreColor: true,
      className: "mr-4 fill-current"
    }), t('PREMIUM_EXCLUSIVE')]
  }));
};
export default PremiumExclusiveTag;
var _StyledP = /*#__PURE__*/_styled("p").withConfig({
  componentId: "sc-jzukwm-0"
})(["\n        /* Special case for border-radius to match the circular icon edge */\n        border-radius: 23px;\n        backdrop-filter: blur(8px);\n        ", "\n      "], function (p) {
  return p.$_css;
});